import React from 'react';
import { TooltipTrigger, SparkIcon } from '@spark';
import { colors } from '@/shared/tokens/colors';

// Shared classification success / error indicator. Renders a green check
// when ``actual`` is part of ``expected`` (or both sides agree on "no
// label"), otherwise a red cross. Used by the Evaluation page's
// ``ModelResponsesTable`` and by the Playground (list + detail) for the
// classification task type so the two surfaces stay in lock-step.
//
// ``expected`` is the ground-truth array (labels the prediction should
// match against); ``actual`` is one predicted label (or ``null`` when
// the model returned no label at all).
const isPredictionCorrect = (actual, expected) => {
    const expectedArr = Array.isArray(expected) ? expected : [];
    return expectedArr.includes(actual) || (actual === null && expectedArr.length === 0);
};

const LabelPredictionStatusIcon = ({ actual, expected, size = 16 }) => {
    const isCorrect = isPredictionCorrect(actual, expected);
    return (
        <TooltipTrigger text={isCorrect ? 'Correct prediction' : 'Incorrect prediction'}>
            {/* top: -1.5px — optical nudge so the icon centers on the label glyphs
                (flex centering aligns it to the 22px line box, which reads ~1-2px low) */}
            <span style={{ display: 'inline-flex', position: 'relative', top: -1.5, color: isCorrect ? colors.green : colors.red }}>
                <SparkIcon slug={isCorrect ? 'circle-check' : 'circle-x'} size={size >= 24 ? 'medium' : 'small'} />
            </span>
        </TooltipTrigger>
    );
};

export default LabelPredictionStatusIcon;
export { isPredictionCorrect };
